/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-23T16:08:43+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-28T17:52:47+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MInputText from './MInputText';
import ODatePickerButton from './../../datepicker/components/ODatePickerButton';
import {
  createDateMask,
  createDateParser,
  createDateFormatter,
} from './../masks/dateMask';

const DATE_FORMAT = 'D.M.Y';

/**
 * OInputDate - …
**/
class OInputDate extends Component {
  constructor(props) {
    super(props);

    const initialValue = (this.isControlled()) ? props.value : props.defaultValue;

    this.state = {
      value: initialValue,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.isControlled()) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  render() {
    const {
      id,
      value, // eslint-disable-line no-unused-vars
      defaultValue,
      disabled,
      mask,
      parser, // eslint-disable-line no-unused-vars
      formatter, // eslint-disable-line no-unused-vars
      placeholder,
      guide,
      placeholderChar,
      keepCharPositions,
      maxDate,
      minDate,
      onChange, // eslint-disable-line no-unused-vars
      ...other
    } = this.props;

    return (
      <div className="o-input o-input-date">
        <MInputText
          {...other}
          id={id}
          value={this.state.value}
          defaultValue={defaultValue}
          disabled={disabled}
          mask={mask}
          placeholder={placeholder}
          guide={guide}
          placeholderChar={placeholderChar}
          keepCharPositions={keepCharPositions}
          actions={
            <ODatePickerButton
              value={this.getDateValueForPicker(this.state.value)}
              disabled={disabled}
              labelCancel={'Abbrechen'}
              labelOk={'Ok'}
              maxDate={maxDate}
              minDate={minDate}
              onChange={(_, date) => this.handleOnChangeDate(_, date)}
              startWithYears={this.props.startWithYears}
            />
          }
          onChange={(e) => this.handleOnChange(e)}
        />
      </div>
    );
  }

  getDateValueForPicker(value) {
    const {parser, pickerFallbackDate} = this.props;
    const dateValue = parser(value);
    if (dateValue === null) {
      return pickerFallbackDate;
    }
    return dateValue;
  }

  handleOnChange(event) {
    const value = event.target.value;

    if (!this.isControlled()) {
      this.setState({value});
    }

    this.fireOnChange(event, value);
  }

  handleOnChangeDate(_, date) {
    const {formatter} = this.props;
    const formattedDate = formatter(date);

    if (!this.isControlled()) {
      this.setState({
        value: formattedDate,
      });
    }

    this.fireOnChange(null, formattedDate);
  }

  fireOnChange(event, value) {
    const {onChange} = this.props;
    if (onChange) onChange(event, value);
  }

  isControlled() {
    return Object.prototype.hasOwnProperty.call(this.props, 'value');
  }
}
OInputDate.propTypes = {
  /**
     * id of the input field to link it with a labels htmlFor attribute
     */
  id: PropTypes.string,
  /**
     * value of the input
     * NOTE: wont really work as a controlled comp, as the input
     * changes nervertheless due to masked-input
     * it isn't suggested to use it as a controlled component
     */
  value: PropTypes.string,
  /**
     * default value of the input
     */
  defaultValue: PropTypes.string,
  /**
     * disable input
     */
  disabled: PropTypes.bool,
  /**
     * placeholder value for the input
     */
  placeholder: PropTypes.string,
  /**
    * function or array which describes the format-mask of the input
    */
  mask: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.array.isRequired,
  ]),
  /*
     * guide is a boolean that tells the input whether to be in guide or no guide mode.
     * see: https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#guide
     */
  guide: PropTypes.bool,
  /*
     * The placeholder character represents the fillable spot in the mask.
     * see: https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#placeholderchar
     */
  placeholderChar: PropTypes.string,
  /*
     * When true, adding or deleting characters will not affect the positions of existing characters.
     * see: https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#keepcharpositions
     */
  keepCharPositions: PropTypes.bool,
  /**
     * function which parses the input string-value and returns it
     * as a date or null
     */
  parser: PropTypes.func.isRequired,
  /**
     * function which uses the Date value and formats it similar to the mask
     */
  formatter: PropTypes.func.isRequired,
  /**
     * max date for the date-picker
     * it isn't a garantee that the user doesn't type a date which
     * is outside the range – this should be part of a validation function
     */
  maxDate: PropTypes.object,
  /**
     * min date for the date-picker
     * it isn't a garantee that the user doesn't type a date which
     * is outside the range – this should be part of a validation function
     */
  minDate: PropTypes.object,
  /**
     * fired, when the input value changes, it is changed
     * by typing the input, it passes (event, value)
     * if is changed by datepicker it passes (null, value)
     * the value will always be the masked date as a string
     * generated by formatter and mask
     */
  onChange: PropTypes.func,
  /**
     * this date will be used for the datepicker if no model value is available
     */
  pickerFallbackDate: PropTypes.object,
};
OInputDate.defaultProps = {
  placeholder: 'tt.mm.jjjj',
  placeholderChar: '_',
  mask: createDateMask({dateFormat: DATE_FORMAT}),
  parser: createDateParser({dateFormat: DATE_FORMAT}),
  formatter: createDateFormatter({dateFormat: DATE_FORMAT}),
  pickerFallbackDate: (new Date()),
};
export default OInputDate;

